var blocVideo = document.querySelectorAll('.retour-item--video .retour-item__media');
var blocVideoIframe = document.querySelectorAll('.retour-item--iframe .retour-item__media');
var videoIframeSrc = document.querySelectorAll('.retour-item--iframe .popup-area iframe');
var closePopupArea = document.querySelectorAll('.retour-item--video .close-area-popup');

for (let i = 0; i < blocVideo.length; i++) {
    blocVideo[i].addEventListener('click', function () {
        blocVideo[i].closest('.retour-item--video').querySelector('.popup-area').classList.add('show-popup');
    })
}

for (let i = 0; i < blocVideoIframe.length; i++) {
    blocVideoIframe[i].addEventListener('click', function () {
        if ( !videoIframeSrc[i].getAttribute('src') ) {
            videoIframeSrc[i].setAttribute('src', videoIframeSrc[i].getAttribute('data-src'));
        }
    })
}

for (let i = 0; i < closePopupArea.length; i++) {
    closePopupArea[i].addEventListener('click', function () {
        blocVideo[i].closest('.retour-item--video').querySelector('.popup-area').classList.remove('show-popup');

        for (let i = 0; i < blocVideoIframe.length; i++) {
            videoIframeSrc[i].removeAttribute('src');
        }
    })
}